import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '@/shared/components/ui/alert';
import { Button } from '@/shared/components/ui/button';
import { formatTimeAgo } from '@/shared/utils/formatTimeAgo';
import i18n from '@/core/i18n/config';

interface NoteVersionBannerProps {
  createdAt: string;
  onClose: () => void;
  onRestore: () => void;
  isRestoring: boolean;
}

/** Replaces `NoteToolbar` while the editor shows a read-only historical version instead of the live note. */
export function NoteVersionBanner({
  createdAt,
  onClose,
  onRestore,
  isRestoring,
}: NoteVersionBannerProps) {
  const { t } = useTranslation('notes');

  return (
    <Alert
      className="flex flex-col gap-2 rounded-none border-x-0 border-t-0 sm:flex-row sm:items-center sm:justify-between"
      data-testid="notes-version-banner"
    >
      <AlertDescription>
        {t('versionBanner.viewing', { time: formatTimeAgo(createdAt, i18n.language) })}
      </AlertDescription>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onClose}
          data-testid="notes-version-banner-close"
        >
          {t('versionBanner.close')}
        </Button>
        <Button
          size="sm"
          onClick={onRestore}
          disabled={isRestoring}
          data-testid="notes-version-banner-restore"
        >
          {t('versionBanner.restore')}
        </Button>
      </div>
    </Alert>
  );
}
